const achievementsData = [
  { id: 1, label: "مجموع ساعات التطوع", icon: "/images/clock.png" },
  { id: 2, label: "عدد المتطوعين", icon: "/images/person.png" },
  { id: 3, label: "عدد فرص التطوع", icon: "/images/hand.png" },
];

export default achievementsData;